import React from 'react';
import { motion } from 'framer-motion';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

function Timer({ timeLeft, totalTime = 30, size = 90 }) {
  const ratio = timeLeft / totalTime;
  const isUrgent  = timeLeft <= 5;
  const isWarning = timeLeft <= 10 && timeLeft > 5;

  const pathColor = isUrgent  ? '#ef4444'
                  : isWarning ? '#f97316'
                  : '##003DA5';

  const textColor = isUrgent  ? '#ef4444'
                  : isWarning ? '#f97316'
                  : '#ffffff';

  const trailColor = 'rgba(255,255,255,0.08)';

  return (
    <motion.div
      style={{ width: size, height: size, position: 'relative' }}
      animate={isUrgent ? { scale: [1, 1.06, 1] } : {}}
      transition={isUrgent ? { duration: 0.5, repeat: Infinity } : {}}
    >
      {/* Halo de fond */}
      <div
        style={{
          position: 'absolute',
          inset: -6,
          borderRadius: '50%',
          background: isUrgent
            ? 'radial-gradient(circle, rgba(239,68,68,0.15) 0%, transparent 70%)'
            : isWarning
            ? 'radial-gradient(circle, rgba(249,115,22,0.12) 0%, transparent 70%)'
            : 'radial-gradient(circle, rgba(34,197,94,0.08) 0%, transparent 70%)',
          transition: 'background 0.5s',
        }}
      />

      <CircularProgressbar
        value={ratio * 100}
        text={`${timeLeft}`}
        styles={buildStyles({
          pathColor,
          trailColor,
          textColor,
          textSize: '32px',
          pathTransitionDuration: 0.9,
          strokeLinecap: 'round',
        })}
      />

      {/* Override du style du texte pour la font gaming */}
      <style>{`
        .CircularProgressbar .CircularProgressbar-text {
          font-family: 'Rajdhani', sans-serif !important;
          font-weight: 900 !important;
          dominant-baseline: middle !important;
        }
      `}</style>
    </motion.div>
  );
}

export default Timer;

